/* eslint-disable radix */
import { getHost } from '@helper_config';
import { StripHtmlTags } from '@helper_text';
import { modules } from '@config';
import { filterScriptTag } from '@helpers/formInput';

const generate = (product) => {
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();

    today = `${yyyy}-${mm}-${parseInt(dd) + 1}`;
    const schema = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: filterScriptTag(product.name),
        image: product.image.url,
        description: StripHtmlTags(product.description.html),
        sku: filterScriptTag(product.sku),
        gtin: product.id,
        gtin12: product.id,
        gtin13: product.id,
        gtin14: product.id,
        gtin8: product.id,
        mpn: product.id,
        brand: modules.brands.enabled ? product.brand : '',
        offers: {
            '@type': 'Offer',
            priceCurrency: product.price_range.minimum_price.final_price.currency,
            url: `${getHost()}/${product.url_key}`,
            availability: product.stock_status === 'IN_STOCK' ? 'https://schema.org/InStock' : 'https://schema.org/OfStock',
            price: product.price_range.minimum_price.final_price.value,
            priceValidUntil: today,
        },
    };

    if (product.review.rating_summary) {
        schema.aggregateRating = { // sementara di comment soalnya datanya belum
            '@type': 'AggregateRating',
            bestRating: product.review.rating_summary ? parseInt(product.review.rating_summary, 0) / 20 : 1,
            ratingCount: product.review.reviews_count ? product.review.reviews_count : 1,
            ratingValue: product.review.rating_summary ? parseInt(product.review.rating_summary, 0) / 20 : 1,
        };
    }

    if (product.reviews && product.reviews.items && product.reviews.items.length > 0) {
        schema.review = product.reviews.items.map((review) => ({
            '@type': 'Review',
            reviewBody: filterScriptTag(review.text),
            author: {
                '@type': 'Person',
                name: filterScriptTag(review.nickname),
            },
            reviewRating: {
                '@type': 'Rating',
                name: parseInt(review.average_rating / 20, 10),
            },
        }));
    }
    return [
        schema,
    ];
};

export default generate;
